$bog_bzrl_app_nav $mol_view
	sub /
		<= Rent_button $mol_link
			arg *
				tab \rent
				section \rent
			sub /
				<= rent_label @ \Rent
		<= Let_link $mol_link
			arg *
				tab \let
				section \let
			sub /
				<= let_label @ \Let
		<= Home_icon $mol_button_minor
			sub /
				<= home_icon_img $mol_image
					uri \bog/bzrl/assets/HomeRent-Design-System-Frame-71.png
